// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"108":"c8769e3d0a6c3e075825","245":"6368fc10313a2120556f","452":"22962aad144e5464c4d3"}[chunkId] + ".js";
};